import { useState, useEffect, useRef } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface SiteLogo {
  url: string | null;
  alt_text: string | null;
}

export const useSiteLogo = () => {
  const [siteLogo, setSiteLogo] = useState<SiteLogo>({
    url: null,
    alt_text: null
  });
  const [loading, setLoading] = useState(true);
  const channelRef = useRef<any>(null);

  

  useEffect(() => {
    
    fetchSiteLogo();
    
    // إنشاء channel بأسم فريد لكل instance
    const channelName = `site_content_changes_${Math.random().toString(36).substr(2, 9)}`;
    
    // اشتراك في التغييرات المباشرة
    // channelRef.current = supabase
    //   .channel(channelName)
    //   .on(
    //     'postgres_changes',
    //     {
    //       event: '*',
    //       schema: 'public',
    //       table: 'site_content',
    //       filter: 'content_type=eq.site_logo'
    //     },
    //     (payload) => {
          
    //       fetchSiteLogo();
    //     }
    //   )
    //   .subscribe();

    // return () => {
      
    //   if (channelRef.current) {
    //     supabase.removeChannel(channelRef.current);
    //     channelRef.current = null;
    //   }
    // };
  }, []);

  const fetchSiteLogo = async () => {
    
    try {
      const { data, error } = await supabase
        .from('site_content')
        .select('content, image_url')
        .eq('content_type', 'site_logo')
        .eq('is_active', true)
        .maybeSingle();

      if (error && error.code !== 'PGRST116') {
        throw error;
      }

      if (data) {
        // console.log('fetchSiteLogo: Found data:', data);
        const content = data.content as any;
        setSiteLogo({
          url: content?.url || data.image_url,
          alt_text: content?.alt_text || 'شعار الموقع'
        });
        // console.log('fetchSiteLogo: Logo set to:', {
        //   url: content?.url || data.image_url,
        //   alt_text: content?.alt_text || 'شعار الموقع'
        // });
      } else {
        // console.log('fetchSiteLogo: No data found, using default logo');
        // استخدام الشعار الافتراضي
        setSiteLogo({
          url: "/lovable-uploads/ceeee985-6f40-459e-8179-d315fbab21ab.png",
          alt_text: 'شعار الموقع'
        });
      }
    } catch (error) {
      console.error('Error fetching site logo:', error);
      // استخدام الشعار الافتراضي عند حدوث خطأ
      setSiteLogo({
        url: "/lovable-uploads/ceeee985-6f40-459e-8179-d315fbab21ab.png",
        alt_text: 'شعار الموقع'
      });
    } finally {
      setLoading(false);
      
    }
  };

  
  return { siteLogo, loading };
};